export const getLagoonSuicideAndCrisisCardTabs = (suicideAndCrisisInfos) =>
  suicideAndCrisisInfos?.flatMap(
    (suicideAndCrisisInfo: { activeTabs: string }) =>
      suicideAndCrisisInfo.activeTabs?.split(', ').map((part) => part.trim())
  );
